import React from 'react';

import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Box from '@mui/material/Box';
import { PatientRecovery } from './PatientRecovery/PatientRecovery';
import StyledRecoveryPlan from './RecoveryPlan.style';
import { RecoveryPlanType } from 'types/RecoveryPlan';

const RecoveryPlan: React.FC<{
  recoveryPlan?: RecoveryPlanType | null;
  setJointData:any;
  jointData:any;
  patientId: string;
  updateRecoveryPlanData: (recoveryPlan?: RecoveryPlanType) => void;
}> = (props) => {
  return (
    <StyledRecoveryPlan>
      <AccordionSummary>
        <Box display="flex" alignItems="center">
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              marginRight: '12px'
            }}
          >
            <ExpandMoreIcon />
          </Box>
          <Typography
            variant="h6"
            sx={{
              color: '#161728',
              borderRadius: '10px',
              padding: '10px 20px',
              display:"flex",
              alignItems:"center",
            }}
          >
            Recovery Plan
            <Typography sx={{ml:"5px"}} variant="subtitle1" color="text.secondary" >( {props.recoveryPlan?.joint?.side?.toLocaleLowerCase()} )</Typography>
          </Typography>
        </Box>

      </AccordionSummary>
      <Typography
        sx={{ padding: '10px 20px' }}
        component="div"
        id="recovery-plan-content"
        aria-labelledby="recovery-plan-header"
      >
        <PatientRecovery
          recoveryPlan={props.recoveryPlan}
          patientId={props.patientId}
          setJointData={props.setJointData}
          jointData={props.jointData}
          updateRecoveryPlanData={props.updateRecoveryPlanData}
        />
      </Typography>
    </StyledRecoveryPlan>
  );
};

export default RecoveryPlan;
